import { Component, OnInit } from '@angular/core';
import { BsModalService } from 'ngx-bootstrap/modal';
import { LeadsService } from 'src/app/services/leads.service';
import { MessageServiceService } from 'src/app/services/message-service.service';

@Component({
  selector: 'app-call-history',
  templateUrl: './call-history.component.html',
  styleUrls: ['./call-history.component.scss']
})
export class CallHistoryComponent implements OnInit {
  staticCallHistory: any[]=[];
  mobileNo:any;
  selectedCallDate:any;

  constructor(private messageService: MessageServiceService,
    private modalService: BsModalService,
    private leadsService: LeadsService,) { }

  ngOnInit() {
    this.getCallData();
  }
  selectedCallType: string = 'OUT (CustomerCall)'; // Default selection
  
  getCallData() {
    debugger;
    let leadData = JSON.parse(localStorage.getItem("CurrentOutBoundCallMobileNumber"));
  

    // ✅ Call API with selectedCallType (IN / OUT)
    this.leadsService.GetCallHistory(this.selectedCallType,this.selectedCallDate,this.mobileNo).subscribe(
      (res: any) => {
        debugger;
        this.staticCallHistory = res.response || [];
        console.log("Call History:", this.staticCallHistory);
      },
      (error) => {
        this.messageService.showErrorMessage("Unable to retrieve call disposition data from server");
      }
    );
  }
  
  // Trigger API call when dropdown value changes
  onCallTypeChange(event: any) {
    this.selectedCallType = event.target.value;
   
  }
  
  filterByCreatedDate(){
    this.getCallData();
  }  

}
